import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../api/api';
import '../../styles/auth/CenterCodeEntryPage.css';

const CenterCodeEntryPage = () => {
  const [centerCode, setCenterCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleContinue = async (e) => {
    e.preventDefault();
    
    if (!centerCode.trim()) {
      setError('Please enter the center code');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await api.post('/registrations/validate-center-code', { centerCode });
      
      if (response.data.success) {
        // Navigate to registration screen with center info
        navigate('/register/parent', {
          state: {
            centerId: response.data.center.id,
            centerName: response.data.center.name,
            centerCode: centerCode,
            registrationSettings: response.data.center.registrationSettings
          }
        });
      } else {
        setError('Failed to validate center code');
      }
    } catch (error) {
      console.error('Center code validation error:', error);
      setError(error.response?.data?.message || 'Invalid center code');
    } finally {
      setLoading(false);
    }
  };

  const handleHelpClick = () => {
    alert('Contact your Quran School Admin to get the school/center code. This code is used to associate your registration with the correct school/center.');
  };

  return (
    <div className="center-code-container">
      <div className="center-code-card">
        <div className="center-code-header">
          <h1>Welcome to memorAIze</h1>
          <p className="subtitle">
            Please enter the code provided by your Quran School or Tahfeeth Center
          </p>
        </div>
        
        <form onSubmit={handleContinue} className="center-code-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <input
              type="text"
              className="center-code-input"
              placeholder="Enter center code"
              value={centerCode}
              onChange={(e) => setCenterCode(e.target.value.toUpperCase())}
              maxLength={6}
              autoCapitalize="characters"
              autoCorrect="off"
              spellCheck="false"
              disabled={loading}
            />
          </div>
          
          <button 
            type="submit" 
            className="continue-button"
            disabled={loading}
          >
            {loading ? 'Validating...' : 'Continue'}
          </button>
        </form>
        
        <div className="help-section">
          <button 
            className="help-button"
            type="button"
            onClick={handleHelpClick}
          >
            Need help?
          </button>
        </div>
        
        <div className="login-link-container">
          <p>Already have an account?</p>
          <Link to="/login" className="login-link">Sign in here</Link>
        </div>
      </div>
    </div>
  );
};

export default CenterCodeEntryPage;
